import classNames from 'classnames';
import React, { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import Modal from 'layout/atoms/Modal/Modal';
import { openModal } from 'store/layoutSlice';
import Label from '../Label';
import styles from './ExpandableLinkList.module.scss';
const MAX_VISIBLE = 6;
function ExpandableLinkList({ links, maxWidth, title }) {
    const dispatch = useDispatch();
    const modalName = useMemo(() => `expandable-link-list-${Math.random().toString(36).slice(2)}`, []);
    const visibleLinks = links.slice(0, MAX_VISIBLE);
    const remainingCount = links.length - MAX_VISIBLE;
    const renderLink = (link) => link.to ? (React.createElement(Link, { to: link.to, className: styles.link }, link.label)) : (React.createElement("button", { type: "button", className: styles.link, onClick: link.onClick }, link.label));
    return (React.createElement(React.Fragment, null,
        React.createElement("ul", { className: styles.wrap, style: { maxWidth } },
            visibleLinks.map((link) => (React.createElement("li", { key: link.id, className: styles.item }, renderLink(link)))),
            remainingCount > 0 && (React.createElement("button", { type: "button", className: classNames(styles.item, styles.more), onClick: () => dispatch(openModal({ name: modalName })) },
                "(show ",
                remainingCount,
                " more)"))),
        React.createElement(Modal, { name: modalName, size: "s", header: React.createElement(Label, { weight: "strong" }, title) },
            React.createElement("ul", { className: styles.wrap }, links.map((link) => (React.createElement("li", { key: link.id, className: styles.item }, renderLink(link))))))));
}
export default ExpandableLinkList;
